import Button from '../../Button'
import Box from '../../Modal/Box'
import Buttons from '../../Modal/Buttons'
import { Content } from '../../Modal/Content'
import { Container } from '../Container'

function ModalSizeS({ children }) {
  return (
    <Container label='Modal, size S - 320px, max height - 440px'>
      <Box size='s'>
        <Content size='s'>{children}</Content>
        <Buttons size='s'>
          <Button.Contained text='Save' />
          <Button.Outlined text='Cancel' />
        </Buttons>
      </Box>
    </Container>
  )
}

export default ModalSizeS
